function _videoResize(section) {
  var video = $(section).find('.embed-responsive');
  var container = $(section).find('.cover');

  var translation = (video.height() - container.height() ) / 2;

  video.css('transform', 'translateY(-' + translation + 'px)');
}

export function ComponentVideo() {
  $('.section-video').each(function () {
    if ($(this).find('.cover').length > 0) {
      var section = this;
      var player = new Vimeo.Player($(section).find('iframe').get(0));

      $(section).find('.button-play').on('click', function(e) {
        e.preventDefault();

        player.play();

        $(this).fadeOut();
      });

      player.on('ended', function () {
        $(section).find('.button-play').fadeIn();
      });
   
      $(window).on('resize', function() {
        _videoResize(section);
      });

      _videoResize(section);
    }
  });
}
